import React from 'react';
import { stats } from '../data/content';
export function Stats() {
  return <section className="w-full bg-white px-4 py-8 sm:px-6 sm:py-12" aria-label="Resultados en cifras" data-id="element-217" data-mp="2wxqf6edmwmjh">
      <div className="mx-auto grid max-w-4xl grid-cols-2 gap-x-4 gap-y-7 sm:grid-cols-4 sm:gap-6" data-id="element-218" data-mp="2iyqnexutrrj3">
        {stats.map(stat => <div key={stat.label} className="flex flex-col items-center text-center" data-id="element-219" data-mp="2nvh3vmajkp51">
            <span className="font-display text-[26px] font-black leading-none text-navy-900 sm:text-4xl" data-id="element-220" data-mp="297cha78dbtgz">
              {stat.value}
            </span>
            <span className="mt-2 text-[11px] font-semibold uppercase leading-snug tracking-wide text-navy-800/60 sm:text-xs" data-id="element-221" data-mp="207g0ers7zywh">
              {stat.label}
            </span>
          </div>)}
      </div>
    </section>;
}